import * as Yup from 'yup';

const signInSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Invalid email"),
    password: Yup.string().required('Password is required'),
});

export default signInSchema;